import styled from 'react-emotion';
import { themeGet } from 'styled-system';

// @flex
// @border
// @letter-spacing
export const Tag = styled('span')`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border-color: ${props =>
    props.available ? themeGet('colors.teal') : themeGet('colors.yellowDark')};
  text-transform: uppercase;
  color: ${props =>
    props.available ? themeGet('colors.teal') : themeGet('colors.yellowDark')};
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.1px;
  border: 1.8px solid;
  padding: ${themeGet('space.1')}px ${themeGet('space.2')}px;
  width: 100%;
`;

// @flex
// @border
// @box-shadow
export const Card = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 0.7px solid ${themeGet('colors.greyLight')};
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.15s linear;
  width: 100%;
  @media screen and (min-width: 76em) {
    &:hover {
      transform: translateY(-1px);
      -moz-transform: none;
      -ms-transform: none;
      box-shadow: 0 30px 30px 0 rgba(36, 50, 66, 0.1);
    }
  }
`;

export const CardBody = styled('div')`
  padding: ${themeGet('space.2')}px ${themeGet('space.2')}px;
  border-bottom: 1px solid ${themeGet('colors.greyLight')};
  width: 100%;
  cursor: pointer;
  // TODO: images on wide screens
  @media screen and (min-width: 76em) {
    padding: ${themeGet('space.4')}px ${themeGet('space.4')}px;
  }
`;

// @flex
// @padding
export const CardFooter = styled('div')`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${themeGet('space.5')}px ${themeGet('space.4')}px
    ${themeGet('space.4')}px ${themeGet('space.4')}px;
`;

// @flex
// @width
// @padding

export const CardFooterRow = styled('div')`
  width: 100%;
  padding: ${themeGet('space.2')}px ${themeGet('space.2')}px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background-color: ${themeGet('colors.greyLighter')};
`;

export const CardFooterColumn = styled('div')`
  display: flex;
  flex-direction: column;
  width: 50%;
`;

// @flex
// @wdith
export const CardDetail = styled('section')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

export const CardDetailImage = styled('div')`
  min-height: 50vh;
  min-width: 50vw;
  max-height: 100%;
  max-width: 100%;
`;



// WEBPACK FOOTER //
// ../shop_main/components/card/style.js